import { BaseSidebarObject } from '@y42/gojs';
import { TextAlignment } from '@y42/json-schema';
import { ILockedNode, IShadowNode, ITextNode, IZOrderableNode } from '../../common/models/node.interfaces';

export class TextNode extends BaseSidebarObject implements ITextNode, IShadowNode, ILockedNode, IZOrderableNode {
  constructor(
    public key = '',
    public category = '',
    public text = '',
    public font = '',
    public textColor = '',
    public textHighlightColor = '',
    public textAlignment = TextAlignment.Left,
    public locked = false,
    public location = '0 0',
    public shadowColor = '',
    public shadowOffset = '',
    public shadowBlur = 0,
    public layerName = '',
    public zOrder = NaN,
  ) {
    super();
  }
}
